export function showLoading(){
  var loadingBack = document.createElement('div');
  loadingBack.classList.add("loadingBack");
  document.getElementsByTagName('body')[0].appendChild(loadingBack);document.body.classList.add('loading-fixed');
  var message = document.createElement('pre');
  message.innerText=document.getElementById('loader_str').dataset.str;
  message.classList.add("loadingMessage");
  document.getElementsByTagName('body')[0].appendChild(message);
}

export function hideLoading() {
  document.getElementsByClassName('loadingBack')[0].remove();
  document.getElementsByClassName('loader')[0].remove();
  document.body.classList.remove('loading-fixed');
}

globalThis.showLoading = new Event('showLoading');
window.addEventListener('showLoading', () => {
  showLoading();
});

globalThis.hideLoading = new Event('hideLoading');
window.addEventListener('hideLoading', () => {
  hideLoading();
});


// WEBPACK FOOTER //
// ./app/javascript/packs/loading.js